import type { Skin, SkinId } from "./types";

/** Clean modern vector — the default "Studio" look. */
export const studioSkin: Skin = {
  id: "studio",
  label: "Studio",
  roughness: 0,
  surface: "#eef6ff",
  ink: "#1e293b",
  strokeWidth: 2,
  inkOutlines: false, // shapes use their own strokes/fills as authored
  textInk: "#0f172a",
  fontFamily: "Inter, system-ui, sans-serif",
};

/** Hand-drawn — Rough.js sketchy outlines on paper, flat colored fills. */
export const handDrawnSkin: Skin = {
  id: "handdrawn",
  label: "Hand-drawn",
  roughness: 1.4,
  surface: "#fbfbf6",
  ink: "#1a1a1a",
  strokeWidth: 2.4,
  inkOutlines: true, // outlines become sketchy ink; fills stay flat-colored
  textInk: "#1a1a1a",
  fontFamily: "'Caveat','Comic Sans MS','Segoe Print',Inter,sans-serif",
};

/** Flat (unDraw-like) — clean flat fills, no outlines, soft surface. */
export const flatSkin: Skin = {
  id: "flat",
  label: "Flat",
  roughness: 0,
  surface: "#eef2f7",
  ink: "#475569",
  strokeWidth: 0, // no outlines
  inkOutlines: false,
  textInk: "#1e293b",
  fontFamily: "Inter, system-ui, sans-serif",
};

/** Doodle (Open Peeps-like) — thick sketchy ink outlines, flat fills, paper. */
export const doodleSkin: Skin = {
  id: "doodle",
  label: "Doodle",
  roughness: 2.0,
  surface: "#fffdf5",
  ink: "#111827",
  strokeWidth: 3.4,
  inkOutlines: true,
  textInk: "#111827",
  fontFamily: "'Caveat','Comic Sans MS','Segoe Print',Inter,sans-serif",
};

const SKINS: Record<SkinId, Skin> = {
  studio: studioSkin,
  handdrawn: handDrawnSkin,
  flat: flatSkin,
  doodle: doodleSkin,
};

export function getSkin(id: SkinId | undefined | null): Skin {
  return (id && SKINS[id]) || studioSkin;
}
